import { render } from "./RecruitmentContactEditor.vue?vue&type=template&id=555dd763&scoped=true"
import script from "./RecruitmentContactEditor.vue?vue&type=script&lang=js"
export * from "./RecruitmentContactEditor.vue?vue&type=script&lang=js"

import "./RecruitmentContactEditor.vue?vue&type=style&index=0&id=555dd763&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555dd763"]])

export default __exports__